"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdbStore = void 0;
/* eslint-disable no-empty */
const with_async_ittr_1 = require("idb/with-async-ittr");
const utils_1 = require("./utils");
const utils_2 = require("./utils");
const log_1 = require("./log");
const web_file_1 = require("./web_file");
const upgrades = [
    {
        version: 1,
        upgrade(db) {
            const logs = db.createObjectStore("logs", { keyPath: "id" });
            logs.createIndex("date", "date");
            db.createObjectStore("metadata");
        },
    },
];
const Day1 = 24 * 60 * 60 * 1000;
class IdbStore {
    constructor(name, options) {
        this.name = name;
        this.queue = [];
        this.inited = false;
        this.cleaning = false;
        this.state = "unknown";
        this.retryOpenDbPromise = undefined;
        this.config = (0, utils_2.trueAssign)({
            maxCount: 10000,
            expireTime: Day1 / 2,
        }, options);
    }
    static getInstance(name, options) {
        if (!IdbStore.instance) {
            IdbStore.instance = new IdbStore(name, options);
        }
        return IdbStore.instance;
    }
    info(...args) {
        (0, log_1.debug)(...args);
        this.save(Date.now(), "Gol", utils_1.LogLevel.Info, args);
    }
    // private async openTerminatedDB() {
    //   this.info("open terminated db", this.state);
    //   if (this.state === "opening") return;
    //   if (this.state !== "open") {
    //     this.state = "opening";
    //     this.idb = await openDB(this.name, 1);
    //     const transaction = await this.createTransaction("readwrite");
    //     this.info("open terminated db", "opened");
    //     await this.checkQueue(transaction as DbTransaction<"readwrite">);
    //     this.state = "open";
    //   }
    // }
    async init() {
        var _a;
        this.idb = await (0, with_async_ittr_1.openDB)(this.name, 1, {
            upgrade(database, oldVersion, newVersion, transaction, event) {
                for (const task of upgrades) {
                    if (task.version > oldVersion) {
                        task.upgrade(database, transaction);
                    }
                }
            },
            terminated: () => {
                this.state = "closed";
                // when save functions are called, it will open the db again
            },
        });
        this.state = "open";
        const transaction = await this.createTransaction("readwrite");
        const metadata = transaction.objectStore("metadata");
        const logs = transaction.objectStore("logs");
        this.index = (_a = (await metadata.get("index"))) !== null && _a !== void 0 ? _a : 0;
        await this.removeOldLogsByDate(transaction);
        await this.removeOldLogsByCount(transaction);
        this.inited = true;
        const count = await logs.count();
        (0, log_1.debug)("count after delete", count);
        await this.checkQueue(transaction);
        await transaction.done;
        // this.scheduleCleaner();
    }
    async open() {
        try {
            this.idb = await (0, with_async_ittr_1.openDB)(this.name, 1);
            this.state = "open";
            return this.idb;
        }
        catch (error) {
            await (0, utils_2.delay)(1000);
            return this.open();
        }
    }
    async createSafeTransaction(mode = "readonly") {
        if (this.retryOpenDbPromise) {
            await this.retryOpenDbPromise;
            return this.createTransaction(mode);
        }
        if (this.state === "closed") {
            this.retryOpenDbPromise = this.open();
            await this.retryOpenDbPromise;
            this.retryOpenDbPromise = undefined;
            return this.createTransaction(mode);
        }
        try {
            return this.createTransaction(mode);
        }
        catch (e) {
            if ("message" in e &&
                e.message.includes("database connection is closing")) {
                this.state = "closed";
                return this.createSafeTransaction(mode);
            }
            return this.createTransaction(mode);
        }
    }
    createTransaction(mode = "readonly") {
        return this.idb.transaction(["logs", "metadata"], mode);
    }
    async removeOldLogsByDate(transaction) {
        var _a;
        const logs = transaction.objectStore("logs");
        const byDate = logs.index("date");
        const expireDate = Date.now() - this.config.expireTime;
        const logsIt = byDate.iterate(IDBKeyRange.upperBound(expireDate), "prev");
        let deletes = 0;
        for await (const _log of logsIt) {
            (_a = _log.delete) === null || _a === void 0 ? void 0 : _a.call(_log);
            deletes++;
        }
        this.info("removeOldLogsByDate", { from: expireDate, deletes });
    }
    async removeOldLogsByCount(transaction) {
        const logs = transaction.objectStore("logs");
        const count = await logs.count();
        if (count < this.config.maxCount)
            return;
        this.cleaning = true;
        const byDate = logs.index("date");
        const logIt = byDate.iterate(IDBKeyRange.lowerBound(0), "next");
        const deleteSize = count - this.config.maxCount;
        let deletes = deleteSize;
        for await (const _log of logIt) {
            if (deletes === 0)
                break;
            _log.delete();
            deletes--;
        }
        this.info("removeOldLogsByCount", { deleteSize });
        this.cleaning = false;
    }
    async checkQueue(transaction) {
        (0, log_1.debug)("queue", this.queue);
        if (this.queue.length === 0)
            return;
        const logs = transaction.objectStore("logs");
        const metadata = transaction.objectStore("metadata");
        try {
            for (const log of this.queue) {
                this.index++;
                const id = `${this.index}-${log.date}`;
                logs.put(Object.assign(log, { id }));
            }
            metadata.put(this.index, "index");
            await transaction.done;
            // eslint-disable-next-line no-empty
        }
        catch (error) { }
        this.queue = [];
    }
    async save(date, tag, level, args) {
        var _a, _b;
        if (!this.inited || this.cleaning) {
            (0, log_1.debug)("push to queue", date, tag, level, args);
            this.queue.push({ date, tag, level, args });
            return;
        }
        this.index++;
        const id = `${this.index}-${date}`;
        const _log = { id, date, tag, level, args };
        const transaction = await this.createSafeTransaction("readwrite");
        const logs = transaction.objectStore("logs");
        const metadata = transaction.objectStore("metadata");
        try {
            (_a = logs.put) === null || _a === void 0 ? void 0 : _a.call(logs, _log);
            (_b = metadata.put) === null || _b === void 0 ? void 0 : _b.call(metadata, this.index, "index");
            await transaction.done;
        }
        catch (error) { }
    }
    async report() {
        if (!this.idb)
            return Promise.resolve();
        const transaction = await this.createSafeTransaction("readonly");
        const logs = transaction.objectStore("logs");
        const byDate = logs.index("date");
        const logIt = byDate.iterate(IDBKeyRange.lowerBound(0), "next");
        let data = ""; // if you want json JSON.stringify(logs)
        for await (const _log of logIt) {
            const value = _log.value;
            if (!value)
                continue;
            data += (0, utils_2.formatLine)(value.date, value.tag, value.level, value.args);
        }
        const file = new File([data], (0, utils_2.getFilename)(new Date(), 0), {
            type: "text/plain",
        });
        return [new web_file_1.WebFile(file)];
    }
    async clean() {
        const transaction = await this.createSafeTransaction("readwrite");
        return this.removeOldLogsByCount(transaction);
    }
}
exports.IdbStore = IdbStore;
